import { call, put, select } from "redux-saga/effects";
import importer from "common/importer";
const LoyalDonorActions = importer("Stores/Loyalty/Actions");
const { getLoyaltyGameData } = importer("APIs/loyalty", null);
const { tokens } = importer("Stores/Users/Select", null);

export default function* main({ donorSfid }) {
  try {
    const _tokens = yield select(tokens);
    const { token_type, id_token } = _tokens;
    const token = `${token_type} ${id_token}`;
    yield put(LoyalDonorActions.getLoyaltyGameDataLoading());
    const response = yield getLoyaltyGameData(donorSfid, token);
    if (response?.data?.code === "LOYALTY_GAME_DONOR_NOT_FOUND") {
      yield put(LoyalDonorActions.getLoyaltyGameDataFailure(response?.data));
      return;
    }
    // Consolidates the stepsData array into object to make it easier to access the data
    const updatedResponse = {
      ...response,
      data: {
        ...response?.data,
        stepsData: response?.data?.stepsData.sort((a, b) => {
          if (a.completed && !b.completed) return 1;
          if (!a.completed && b.completed) return -1;
          return a.stepNumber - b.stepNumber;
        }),
        stepsMetadata: response?.data?.stepsData.reduce((acc, step) => {
          acc[step.actionKey] = {
            completed: step.completed,
            points: step.points
          };
          return acc;
        }, {})
      }
    };
    if (!response?.data?.isGameActive) {
      yield put(
        LoyalDonorActions.getLoyaltyGameDataFailure({
          message: "Game Inactive",
          code: !updatedResponse?.data?.stepsMetadata?.["FINAL_DONATION"]?.completed ? "GAME_INACTIVE_INCOMPLETE" : "GAME_INACTIVE"
        })
      );
      return;
    }
    yield put(LoyalDonorActions.getLoyaltyGameDataSuccess(updatedResponse));
  } catch (error) {
    yield put(LoyalDonorActions.getLoyaltyGameDataFailure(error));
  }
}
